define([
    "jquery",
    "underscore",
    "marionette",
    "forms/about_us/career_form",
    "behaviors/form_errors_behavior",
    "behaviors/recaptcha_v3_behavior",
    "backbone.syphon",
    "jquery.fileupload",
    "holdon"
], function ($, _, Marionette, CareerForm, FormErrorsBehavior, ReCaptchaV3Behavior) {
    return Marionette.View.extend({
        el: '#content_layout',

        behaviors: {
            formErrors: {
                behaviorClass: FormErrorsBehavior
            },
            recaptcha: {
                behaviorClass: ReCaptchaV3Behavior,
                action: '/about_us/career'
            }
        },

        ui: {
            'form': '#career_form',
            'full_name': '#full_name',
            'email': '#email',
            'phoneCountry': '#phone_country',
            'phoneArea': '#phone_area',
            'phoneRest': '#phone_rest',
            'resumeFile': '#resume_file',
            'resumeName': '#resume_name',
            'resume': '#resume',
            'coverLetterFile': '#cover_letter_file',
            'coverLetterName': '#cover_letter_name',
            'coverLetter': '#cover_letter',
            'agreementCheck': '#agreement_check',
            'applyBtn': '#apply_btn',
            'resumeBtn': '#resume_btn',
            'coverLetterBtn': '#cover_letter_btn',
            'captchaCheckErrorMsg': '.captcha_check_error_msg'
        },

        events: {
            'click @ui.applyBtn': 'applyNow',
            'click @ui.resumeBtn': 'uploadResume',
            'click @ui.coverLetterBtn': 'uploadCoverLetter'
        },

        initialize: function () {
            this.bindUIElements();

            this.form = new CareerForm();

            this.initFileUpload(this.ui.resumeFile, 'resume');
            this.initFileUpload(this.ui.coverLetterFile, 'cover_letter');

            //recaptcha
            this.triggerMethod('init:recaptcha')
        },

        initFileUpload: function ($selector, type) {
            var that = this;
            $selector.fileupload({
                url: '/rest_about_us/' + type,
                dataType: 'json',
                // File selected, put the original name in the textbox
                add: function (e, data) {
                    HoldOn.open({
                        theme: "sk-fading-circle"
                    });
                    data.submit();
                },
                // Upload success, put the server-side name in the hidden input
                done: function (e, data) {
                    type = type.replace(/(\_[a-z])/g, function ($1) {
                        return $1.toUpperCase().replace('_', '');
                    }); // underscore to camelCases
                    that.ui[type + 'Name'].val(data.files[0].name);
                    that.ui[type].val(data.jqXHR.responseJSON.file_path);

                    HoldOn.close();
                },
                // Upload failed, display error + remove name from textbox
                fail: function (e, data) {
                    var errors = {};
                    errors[type] = data.jqXHR.responseJSON.error_msg;

                    that.ui[type + 'Name'].val('');
                    that.ui[type].val('');

                    HoldOn.close();

                    that.triggerMethod('show:errors', errors);
                }
            });
        },

        applyNow: function (e) {
            var that = this;
            if (e) e.preventDefault();
            this.triggerMethod('hide:errors');

            var formData = Backbone.Syphon.serialize(this);
            formData.full_name = formData.full_name.trim();
            formData.email = formData.email.trim();
            formData.phone_country = formData.phone_country.trim();
            formData.phone_area = formData.phone_area.trim();
            formData.phone_rest = formData.phone_rest.trim();
            this.form.set(formData);

            var errors = this.form.validate();

            if (_.size(errors) < 1) {
                this.triggerMethod('validate:recaptcha', function (err, token) {
                    if (err) {
                        var recaptchaError = {captcha_code: 'Google recaptcha can\'t get a token'};
                        that.ui.captchaCheckErrorMsg.text(recaptchaError.captcha_code);
                        // that.triggerMethod('show:errors', recaptchaError);
                        return;
                    }
                    that.triggerMethod('set:token', token, that.ui.form);

                    // after successfully passed through the validation,
                    // reset the form data with recaptcha token.
                    formData = Backbone.Syphon.serialize(that);
                    that.form.set(formData);

                    that.form.validateWithServer({
                        type: 'POST',
                        success: function (model, res) {
                            that.ui.form[0].reset();
                            that.triggerMethod('show:success');
                        },
                        error: function (model, error) {
                            that.ui.captchaCheckErrorMsg.text("");
                            if (error.responseJSON.captcha_check) {
                                that.captchaCheck = error.responseJSON.captcha_check;
                                that.ui.captchaCheckErrorMsg.text(that.captchaCheck);
                            }
                            delete error.responseJSON.captcha_check;
                            that.triggerMethod('show:errors', error.responseJSON);
                        }
                    });
                })
            } else {
                this.triggerMethod('show:errors', errors);
            }
        }
    });
});
